import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ManagedContentItem } from '@app/common-models/managed-content-item';
import { ContentMessagingCardComponent } from '@app/component/content-messaging-card/content-messaging-card.component';
import { ManagedContentAppService } from '@app/service/managed-content-app.service';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

/**
 * Component representing page not found Api call
 * NOTE: This page is currently being used for AppInit failures in a "stripped down" mode.
 * We should ask UI/UX for guidance on how this should look.
 * @Component
 */
@Component({
  standalone: true,
  selector: 'cu-generic-error',
  templateUrl: './generic_error.component.html',
  imports: [ContentMessagingCardComponent, SharedUiLibraryModule]
})
/**
 * Class representing generic error page
 * @export
 * @class GenericErrorComponent
 */
export class GenericErrorComponent implements OnInit {
  private readonly contentAppService = inject(ManagedContentAppService);
  private readonly router = inject(Router);
  @Input()
  public pageContent?: ManagedContentItem;

  public ngOnInit(): void {
    // If APP_INIT succeeded on this page load, the user shouldn't be on /oops.
    // This handles the reload scenario: APP_INIT failed -> /oops -> user refreshes -> APP_INIT succeeds.
    // Redirect them to /error/404 so they don't get stuck on the oops page.
    if (!(globalThis as Record<string, unknown>).__APP_INIT_ERROR__) {
      this.router.navigate(['/error/404']);
      return;
    }

    if (!this.pageContent) {
      this.contentAppService.getManagedContentForPage('Error').subscribe((data) => {
        this.pageContent = data || ({} as unknown as ManagedContentItem);
      });
    }
  }
}
